import React from "react";
import "./Projects.css";

const projects = [
  {
    name: "Online Mock Test Platform",
    description:
      "A scalable online examination system with timed mock tests, instant results, performance analytics, and practice tests.",
    image: "./Mocktest SS.png",
    link: "https://drkapil.com.np/",
    tech: "React, Node.js, PostgreSQL, REST API, Cloudflare",
  },
  {
    name: "E-Commerce Website",
    description: "A fully featured e-commerce website built on react with Cart integration and React Router.",
    image: "./Jagriti SS.png",
    link: "https://jagritisurgical.com.np/",
    tech: "React + Vite, React Router, Node.js, PostgreSQL, Cloudflare",
  },
  {
    name: "Academic Website",
    description: "A fully featured Academic website for Articles, Research and Teaching with backend integration and responsive design.",
    image: "./Academic SS.png",
    link: "https://doctorkapil.com.np/",
    tech: "React Router, Nodejs, PostgreSQL, cdnjs, Cloudflare",
  },
  {
    name: "Portfolio Website",
    description: "A modern, responsive portfolio built with React, showcasing my skills and projects.",
    image: "./Website SS.png",
    link: "https://ganeshamgain.com.np",
    tech: "React, Node.Js, PWA, Cloudflare",
  },
  {
    name: "Logo Animation",
    description: "A dynamic, cinematic animation featuring smooth morphing and polished easing.",
    image: "./nirvana.jpg",
    link: "./nirvana animation.mp4",
    tech: "Adobe After Effects",
  },
  {
    name: "Brand Logo & Animation",
    description: "Dynamic and visually engaging logo animation with smooth transitions.",
    image: "./globetrot.png",
    link: "./globetrot animation.mp4",
    tech: "Figma, Adobe After Effects",
  },

  /*{
    name: "AI Chatbot",
    description: "An intelligent chatbot powered by GPT-4, providing instant answers and support.",
    image: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=600&q=80",
    link: "https://yourchatbot.com",
    tech: "Node.js, OpenAI API",
  },
  {
    name: "Task Manager App",
    description: "A productivity app to manage tasks, deadlines, and collaborate with teams.",
    image: "https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=600&q=80",
    link: "https://yourtasks.com",
    tech: "React Native, Firebase",
  }, */
];

const Projects = () => {

  const handleViewClick = (project) => {
    if (project.name === "Brand Logo & Animation" || project.name === "Logo Animation") {
      // Open new window
            const newTab = window.open("", "_blank");

      if (newTab) {
        newTab.document.write(`
          <!DOCTYPE html>
          <html lang="en">
          <head>
            <meta charset="UTF-8">
            <title>${project.name}</title>
            <link rel="icon" href="favicon-black.png" type="image/x-icon">
            <style>
              body {
                background-color: #0a0a0a;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100vh;
                margin: 0;
                color: white;
                font-family: sans-serif;
                flex-direction: column;
              }
              video {
                max-width: 100%;
                max-height: 90%;
                border-radius: 14px;
              }
              .toast-msg {
                position: fixed;
                top: 20px;
                left: 50%;
                transform: translateX(-50%);
                background: rgba(26,26,26,0.95);
                color: white;
                border: 1px solid rgba(129,0,204,0.4);
                padding: 14px 28px;
                border-radius: 12px;
                font-size: 1rem;
                text-align: center;
                box-shadow: 0 8px 32px rgba(129,0,204,0.35);
                backdrop-filter: blur(10px) saturate(140%);
                animation: slideFade 2s forwards;
                z-index: 9999;
              }
              @keyframes slideFade {
                0% { opacity: 0; transform: translate(-50%, -30px) scale(0.9); }
                10% { opacity: 1; transform: translate(-50%, 0) scale(1); }
                80% { opacity: 1; transform: translate(-50%, 0) scale(1); }
                100% { opacity: 0; transform: translate(-50%, -20px) scale(0.95); }
              }
            </style>
          </head>
          <body>
            <video src="${project.link}" autoplay muted controls></video>
            <div class="toast-msg">This is Sample Only!<br> Final Version can be different.</div>
            <script>
              setTimeout(() => {
                const toast = document.querySelector('.toast-msg');
                if (toast) toast.remove();
              }, 5000);
            </script>
          </body>
          </html>
        `);
        newTab.document.close();
      }
    } else {
      // For other projects, open normally
      window.open(project.link, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <section id="projects" className="projects">
      <h2>My Projects</h2>
      <div className="projects-container">
        <div className="projects-grid">
          {projects.map((project, idx) => (
            <div className="project-card" key={idx}>
              <img
                src={project.image}
                alt={project.name}
                className="project-image"
                loading="lazy"
              />
              <div className="project-content">
                <h3 className="project-name">{project.name}</h3>
                <p className="project-description">{project.description}</p>
                <div className="project-meta">
                  <span>{project.tech}</span>
                  <button
                    className="project-link"
                    onClick={() => handleViewClick(project)}
                  >
                    View
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
